/* tslint:disable */
/* eslint-disable */
/**
 * crm-phone-agent
 * crm-phone-agent
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const InsuranceType = {
    Commercial: 'Commercial',
    ManagedMedicaid: 'Managed Medicaid',
    ManagedMedicare: 'Managed Medicare',
    Medicaid: 'Medicaid',
    Medicare: 'Medicare'
} as const;
export type InsuranceType = typeof InsuranceType[keyof typeof InsuranceType];


export function InsuranceTypeFromJSON(json: any): InsuranceType {
    return InsuranceTypeFromJSONTyped(json, false);
}

export function InsuranceTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): InsuranceType {
    return json as InsuranceType;
}

export function InsuranceTypeToJSON(value?: InsuranceType | null): any {
    return value as any;
}

